import { url } from 'inspector';
import React, { useState ,useEffect} from 'react';
import { ACTION_CODE, callApp } from '../../utils/callApp';
import { PAGREE_CODE } from '../../utils/codeEnum';
import './index.css';

enum AGREE_STATE {
   NORMAL = 1,//正常
   CANCEL = 2,//取消
}
const siderWidth = 50;
const siderLeft = 0;
const siderRight = window.innerWidth - siderWidth;
const siderTop = 0;
const siderBottom = window.innerHeight - siderWidth;
const siderCenter = siderBottom/2;

let clickTime = 0;
let timer:any = null;
let clientX = 0;
let clientY = 0;
let ballLeft = 0;
let ballTop = 0;
let ballLeft_bak = -9999;
let canMove = false;
const SiderBall:React.FC<{data:any,onClose:any}> = (props)=> {
  //展示状态
  //渲染球
  const position = props.data.position.split('-');
  let _left = 0;
  let _top = 0;
  switch(position[0]){
    case 'left':
      _left = siderLeft;
      break;
    case 'right':
      _left = siderRight;
      break;
  }
  switch(position[1]){
    case 'top':
      _top = window.innerHeight/3 - siderWidth/2;
      break;
    case 'center':
      _top = siderCenter;
      break;
    case 'bottom':
      _top = window.innerHeight/3*2 - siderWidth/2;
      break;
  }
  const [left, setLeft] = useState((window as any).siderBall_left||_left);
  const [top, setTop] = useState((window as any).siderBall_top||_top);
  const [canMovePage, setCanMove] = useState(0);
  const [opacity, setOpacity] = useState(0.5);
  const isMob = 'ontouchstart' in window;
  const clickInterval = 300;
  let ontouchstartFn:any = null;
  let ontouchendFn:any = null;
  let ontouchmoveFn:any = null;
  let onmousedownFn:any = null;
  let onmouseupFn:any = null;
  let onmousemoveFn:any = null;
  function start(e:any){
    clickTime = +new Date();
    setOpacity(1);
    setCanMove(1);
    canMove = true;
    timer&&clearTimeout(timer);
    if(isMob){
        clientX = e.changedTouches[0].clientX;
        clientY = e.changedTouches[0].clientY;
    }else{
        clientX = e.clientX;
        clientY = e.clientY;
    }
    let _ballLeft =  left;
    if(_ballLeft<siderLeft){
      _ballLeft = siderLeft
    }
    if(_ballLeft>siderRight){
      _ballLeft = siderRight
    }
    ballLeft = _ballLeft;
    ballTop = top;
    if(isMob){

      // document.ontouchmove = ballMove;
      document.addEventListener('touchmove', ballMove, {passive: false})
      document.ontouchend = ballTouchEnd;
    }else{
      document.onmouseup = ballTouchEnd;
      document.onmousemove = ballMove;
    }
    // setTimeout(()=>{
    //   timeOutBack();
    // })
  }
  function ballMove(e:any){
      e.preventDefault();
      if(canMove){
          let currentX = 0
          let currentY = 0;
          if(isMob){
              currentX = e.changedTouches[0].clientX;
              currentY = e.changedTouches[0].clientY;
          }else{
              currentX = e.clientX;
              currentY = e.clientY;
          }
          let skewX = currentX - clientX;
          let skewY = currentY - clientY;
          resetBallPosition(skewX,skewY)
      }
      return;
  }
  function ballTouchEnd(e:any){
    if((+new Date  - clickTime)<clickInterval){
        ballClick();
    }
    setCanMove(0);
    canMove = false;
    document.onmousemove = null;
    // document.ontouchmove = null;
    document.removeEventListener('touchmove', ballMove);
    document.onmouseup = null;
    document.ontouchend = null;
    timeOutBack();
  }
  function resetBallPosition(x=0,y=0){
      let _ballLeft =  ballLeft + x;
      let _ballTop = ballTop + y;
      if(_ballLeft<siderLeft){
          _ballLeft = siderLeft;
      }
      if(_ballLeft>siderRight){
          _ballLeft = siderRight
      }
      if(_ballTop<siderTop){
          _ballTop = siderTop;
      }
      if(_ballTop>siderBottom){
          _ballTop = siderBottom
      }
      setLeft(_ballLeft)
      setTop(_ballTop);
      ballLeft_bak = _ballLeft;
      (window as any).siderBall_top = _ballTop;
      return [_ballLeft,_ballTop]
  }
  function timeOutBack(){
    timer&&clearTimeout(timer);
    timer = setTimeout(()=>{
        //判断距离屏幕距离
        let _ballLeft =  ballLeft_bak;
        if(_ballLeft<window.innerWidth/2){
          _ballLeft = siderLeft - siderWidth/2;
        }else{
          _ballLeft = siderRight + siderWidth/2;
        }        
        setLeft(_ballLeft);
        (window as any).siderBall_left = _ballLeft;
        setOpacity(0.5)
    },1000)
  }
  function ballClick(){
    //触发passport页面打开
    callApp(ACTION_CODE.POST_SIDER,{code:PAGREE_CODE.SUCCESS})
    props.onClose();
  }
  if(isMob){
    ontouchstartFn = start;
    ontouchendFn = ballTouchEnd;
    ontouchmoveFn = ballMove;
  }else{
    onmousedownFn = start;
    onmouseupFn = ballTouchEnd;
    onmousemoveFn = ballMove;
  }
  // timeOutBack()
    // setTimeout(()=>{
    //   timeOutBack();
    // })
    useEffect(() => {
      // Update the document title using the browser API
      if(ballLeft_bak == -9999){
        ballLeft_bak = _left;
      }
      
      timeOutBack();
    },[]);
  return (
    <>
      {canMovePage?<div style={{width:'100%',height:'100%',position:'fixed',left:0,top:0}}></div>:''}
      <div 
        onTouchStart={(e)=>{ontouchstartFn&&ontouchstartFn(e)}} 
        // onTouchEnd={(e)=>{ballTouchEnd&&ballTouchEnd(e)}} 
        // onTouchMove={(e)=>{ontouchmoveFn&&ontouchmoveFn(e)}} 
        onMouseDown={(e)=>{onmousedownFn&&onmousedownFn(e)}} 
        // onMouseUp={(e)=>{onmouseupFn&&onmouseupFn(e)}} 
        // onMouseMove={(e)=>{onmousemoveFn&&onmousemoveFn(e)}} 
        className="siderball"
        style={{opacity, position:'fixed',left:left,top:top,width:`${siderWidth}px`,height:`${siderWidth}px`,...(props.data.icon?{
          backgroundImage:`url(${props.data.icon})`
        }:{})}}>
      </div>
    </>
  );
}



export default SiderBall;
